import { AgentInput, SuggestedQuestion } from '../../../../../../../../store/dashboard/askAica/actions';
import styles from './SuggestionsStrip.module.scss';

interface SuggestionsStripProps {
    questions: SuggestedQuestion[];
    onSelect: (text: string, flowKey?: string, agentInput?: AgentInput) => void;
    testId?: string;
}

function SuggestionsStrip({ questions, onSelect, testId }: SuggestionsStripProps) {
    return (
        <div className={styles.SuggestionsStrip} data-testid={testId}>
            {questions.map((question) => (
                <button
                    type="button"
                    key={question.id}
                    className={styles.SuggestionPill}
                    onClick={() => onSelect(question.text, question.flowKey, question.agentInput)}
                >
                    {question.display ?? question.text}
                </button>
            ))}
        </div>
    );
}

export default SuggestionsStrip;
